<section class="order-container container-fluid">

    <div class="page-header">
        <h3 translate="cart.order.history"></h3>
        <span translate="cart.order.history.range"></span>

        <select [(ngModel)]="selectedDateRange" (change)="onDateRangeChange()" class="form-select" automation-tag="sortDropDown">
            <option *ngFor="let dateRange of dateRanges; trackBy: trackByFn" [ngValue]="dateRange">{{dateRange.display}}</option>
        </select>
    </div>

    <div *ngIf="loading" class="spacer text-center">
        <usana-spinner [show]="loading"></usana-spinner>
    </div>

    <div class="panel panel-default" *ngIf="!loading && !orderViews?.length">
        <div class="panel-body" translate="cart.order.history.empty"></div>
    </div>

    <ng-container *ngIf="!loading && orderViews?.length">
        <div *ngFor="let orderView of orderViews; trackBy: trackByFn">
            <div id="order{{orderView.id}}" class="panel panel-default">

                <div class="panel-heading">
                    <span class="pull-left" translate="cart.order.history.order.placed"></span><span class="fw-bold">&nbsp;{{orderView.orderDate | usanadate: 'mediumDate':orderView.warehouse?.timezone | async}}</span>
                    <a (click)="setActiveOrderView(orderView)"
                       [routerLink]="[ORDER_HISTORY_DETAILS_ROUTE, orderView.id]"
                       translate="cart.order.history.order.details"></a>
                </div>

                <div class="order-summary-container">
                    <order-history-product-row
                        (itemAdded)="addItemToCart($event, orderView.id)"
                        [headerLabels]="headerLabels"
                        [displayVolume]="shouldDisplayVolume"
                        [displayAttributes]="productDisplayAttributes"
                        [orderView]="orderView"></order-history-product-row>

                    <order-history-summary
                        (addFullOrder)="addFullOrderToCart($event, orderView.id)"
                        (viewTracking)="viewTracking($event)"
                        [orderView]="orderView"
                        [trackingCount]="getTrackingCount(orderView)"
                        [canAutoOrder]="canAddAutoOrderOnline && canEditAutoOrderOnline"
                        [displayVolume]="shouldDisplayVolume"></order-history-summary>
                </div>
            </div>
        </div>
    </ng-container>

</section>
